import { render } from "./DoYouKnow.vue?vue&type=template&id=6d70e5c4&scoped=true"
import script from "./DoYouKnow.vue?vue&type=script&lang=js"
export * from "./DoYouKnow.vue?vue&type=script&lang=js"

import "./DoYouKnow.vue?vue&type=style&index=0&id=6d70e5c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d70e5c4"]])

export default __exports__